<div>
    <div class="row">
        <div class="col">
            <div>
                <community-message-card [message]="message" (commentClick)="refreshComments()" (photoClick)="emitPhotoClickEvent($event)" (updateUser)="updateUser($event)"></community-message-card>
                <hr>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="message">
        <div class="col">
            <div>
                <community-new-comment [message]="message" (refreshComments)="refreshComments()"></community-new-comment>
                <hr>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="comments.length > 0">
        <div class="col">
            <div *ngFor="let comment of comments">
                <community-comment-card [comment]="comment" (updateUser)="updateUser($event)"></community-comment-card>
                <hr>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="count > 0 || browseBeforeInProgress">
        <div class="col text-center">
            <button class="btn btn-primary mx-auto mb-3" (click)="browseBefore()" [disabled]="browseBeforeInProgress" [class.progress-bar-striped]="browseBeforeInProgress" [class.progress-bar-animated]="browseBeforeInProgress">
                <div *ngIf="!browseBeforeInProgress">
                    <i class="fas fa-step-forward" style="transform: rotate(90deg)"></i> Next
                </div>
                <div *ngIf="browseBeforeInProgress">
                    <i class="fas fa-hourglass-half"></i> Loading
                </div>
            </button>
        </div>
    </div>
</div>